export { default as SapContractFeeSlot } from './SapContractFeeSlot';
